(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-business-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTrustMotion = () => {
      document.querySelectorAll('.home-business-trust').forEach((section) => {
        const updateMotion = () => section.classList.toggle('is-motion-paused', document.hidden || !inView);
        let inView = false;
        document.addEventListener('visibilitychange', updateMotion);
        const sectionObserver = new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; updateMotion(); }, { threshold: 0.01 });
        sectionObserver.observe(section);
        const stars = section.querySelector('.hbt-stars');
        if (stars) {
          const starsObserver = new IntersectionObserver(([entry], observer) => {
            if (entry.isIntersecting) { stars.classList.add('is-visible'); observer.disconnect(); }
          }, { threshold: 0.45 });
          starsObserver.observe(stars);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTrustMotion, { once: true });
    else initTrustMotion();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
